"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepType = void 0;
var StepType = {
  Question: "Question",
  InterstitialScreen: "Interstitial Screen",
  // Used to introduce the form or a new section,
  SetVariable: "Set Variable" // When the user wants to run calculations in the background without showing the end user a screen
};
exports.StepType = StepType;